import { IonApp, IonContent, IonPage } from "@ionic/react";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import axios from "axios";
import { requestID, baseURL, config } from "../../../common/utils";

function WalletLedger({ wallet }) {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [ledger, setLedger] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const fetchLedger = async () => {
    try {
      setLoading(true);
      const payload = {
        requestID: requestID(),
        walletID: wallet.user_id,
        startDate,
        endDate,
      };

      console.log(wallet.user_id);
      const res = await axios.post(
        `${baseURL}wallets/getAccountStatement`,
        payload,
        config
      );
      setLedger(res.data.data || []);
    } catch (error) {
      console.error("Error fetching account statement:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (wallet?.user_id) {
      fetchLedger();
    }
  }, [wallet]);

  console.log({ ledger });

  const calculateBalance = () => {
    let balance = 0;
    return ledger.map((entry) => {
      const debit = parseFloat(entry.drValue || 0);
      const credit = parseFloat(entry.crValue || 0);
      balance += debit - credit;

      return {
        ...entry,
        balance: balance.toFixed(2),
      };
    });
  };

  const ledgerWithBalance = calculateBalance();

  const totalWithdrawal = ledger.reduce(
    (sum, entry) => sum + parseFloat(entry.crValue || 0),
    0
  );
  const totalDeposit = ledger.reduce(
    (sum, entry) => sum + parseFloat(entry.drValue || 0),
    0
  );

  const closingBalance =
    ledger.length > 0 ? parseFloat(ledger[ledger.length - 1].balValue || 0) : 0;


    const closingBalancex = Number(totalDeposit) - Number(totalWithdrawal);



const formatCurrency =
 (value) => {
  const number = Number(value) || 0; // Safely convert to number
  return `₦${number.toLocaleString('en-NG')}`; // Use Nigerian locale for proper comma separation
};

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        width: "100%",
        maxWidth: "900px",
        maxHeight: "700px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Account Statement
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="body2">
            Transaction statement for {wallet.walletName}
          </Typography>
{/*           <Typography variant="body2">Member ID: {wallet.user_id}</Typography>
 */}        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 2,
          flexWrap: "wrap",
        }}
      >
        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={(newValue) => setStartDate(newValue)}
          sx={{ flex: 1, minWidth: "200px" }}
        />
        <DatePicker
          label="End Date"
          value={endDate}
          onChange={(newValue) => setEndDate(newValue)}
          sx={{ flex: 1, minWidth: "200px" }}
        />
      </Box>

      <Box sx={{ flex: 1, overflow: "auto" }}>
        <Table stickyHeader size="small">
          <TableHead sx={{ backgroundColor: theme.palette.grey[100] }}>
            <TableRow>
              {["Description", "Withdrawal", "Deposit", "Balance"].map(
                (head) => (
                  <TableCell
                    key={head}
                    sx={{ width: head === "Description" ? "40%" : "20%" }}
                  >
                    <Typography variant="subtitle2" fontWeight="bold">
                      {head}
                    </Typography>
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 2 }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : ledgerWithBalance.length > 0 ? (
              ledgerWithBalance.map((entry, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ width: "40%" }}>{entry.desp}</TableCell>
                  <TableCell sx={{ width: "20%" }}>{formatCurrency(entry.crValue)}</TableCell>
                  <TableCell sx={{ width: "20%" }}>{formatCurrency(entry.drValue)}</TableCell>
                  <TableCell sx={{ width: "20%" }}>{formatCurrency(entry.balance)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography variant="body1">No transactions available</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="subtitle1">
            <strong>Total Withdrawal:</strong> {formatCurrency(totalWithdrawal)}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Total Deposit:</strong> {formatCurrency(totalDeposit)}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Closing Balance:</strong> {formatCurrency(closingBalancex)}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}

export default WalletLedger;
 